import { cva } from "class-variance-authority";

/** 28×28, matching the conversation summary header. */
export const entityAvatarRoot = cva("size-7 shrink-0", {
  variants: {
    shape: {
      circle: "rounded-full",
      // Role badges are rounded squares.
      rounded: "rounded-md",
    },
  },
});

/** The always-present fallback: its background, glyph/initials color, and border. */
export const entityAvatarFallback = cva(
  "flex size-full items-center justify-center overflow-hidden",
  {
    variants: {
      shape: {
        circle: "rounded-full",
        rounded: "rounded-md",
      },
      tone: {
        user: "bg-avatar-user text-white",
        group: "bg-avatar-group-bg text-avatar-group",
        forum: "bg-avatar-forum text-white",
        patientCare: "bg-avatar-patient-care text-white",
        // Background is the entity's tag color, applied inline.
        tag: "text-white",
        roleOnTag: "text-white",
        roleOnDarkTag: "text-avatar-role-dark-icon",
        roleDefault: "border border-avatar-initials-border bg-card text-avatar-role-default-icon",
        initials: "border border-avatar-initials-border bg-card text-strong",
        teamUntagged: "bg-avatar-team-untagged text-avatar-team-untagged-fg",
        none: "bg-transparent",
      },
    },
  },
);

/** How large each glyph sits inside the avatar. */
export const entityAvatarGlyph = cva("", {
  variants: {
    glyph: {
      user: "size-full",
      group: "size-full",
      patientCare: "size-full",
      forum: "size-full p-1",
      activatedTeam: "w-3/5",
      role: "w-4",
    },
  },
});

export const entityAvatarStyles = {
  // Uploaded photos are always round, even inside a rounded-square avatar.
  photo: "size-full rounded-full object-cover",
  imageGlyph: "size-full",
  // text-box-cap centers the capitals themselves, not the font's line box.
  initials: "text-xxs font-semibold leading-none text-box-cap",
};
